import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './orderFieldVisibility/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/order-field-visibility'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'order_field_visibility_wrapper',
          meta: {
            featureFlag: FEATURE_FLAGS.SERVICE_ORDERS,
            permissions: ['administrator'],
          },
          redirect: to => {
            return {
              name: 'order_field_visibility_list',
              params: to.params,
            };
          },
        },
        {
          path: 'list',
          name: 'order_field_visibility_list',
          meta: {
            featureFlag: FEATURE_FLAGS.SERVICE_ORDERS,
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
